import PropTypes from "prop-types"

export default function MessageWithIcon({ icon, text }) {
  return (
    <div className="message-with-icon">
      <div className="message-with-icon__icon">{icon}</div>
      <div className="message-with-icon__text">{text}</div>
    </div>
  )
}

MessageWithIcon.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired,
}
